import React, {Component, ReactElement, ReactNode} from 'react'
import ResidentGeneralMeetingRepo, {
    ResidentGeneralMeeting,
    ResidentGeneralMeetingResponse,
    ResidentVotingPreference
} from './ResidentGeneralMeetingRepo'
import {ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import {PlainBackLink} from '../../styledComponents/Links'
import {DialogCloseButton, StyledPageTitle} from '../reservations/components/CommonStyle'
import {getName, NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import {Nullable} from '../../app/TypeHelpers'
import styled from 'styled-components'
import ResidentSectionComponent from '../shared/ResidentSectionComponent'
import ResidentLabeledContentComponent from '../shared/ResidentLabeledContentComponent'
import {formatDatetimeSlashSeparatorFromDate, formatDateWithDayOfTheWeekFromDate} from '../../formatters/formatDate'
import {
    PlainLinkStyledButton,
    StyledSecondaryButton,
    SubmitPrimaryButton,
    UnstyledLinkStyledButton
} from '../../styledComponents/Button'
import {Close, Comment, DeleteForever} from '@mui/icons-material'
import {Box, DialogContent, DialogTitle, Drawer, Popover} from '@mui/material'
import {DisplayItemDividerForPageTop, DisplayItemTitle} from '../../styledComponents/DisplayItem'
import {
    FullWidthColumnFlexContainer,
    FullWidthLeftRowFlexContainer,
    FullWidthRowFlexContainer,
    RowFlexContainer
} from '../../styledComponents/FlexComponents'
import {AttachmentFile, AttachmentFileLink, AttachmentFileName} from '../../styledComponents/ResidentFiles'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEllipsisH, faFilePdf} from '@fortawesome/free-solid-svg-icons'
import {formatFileSizeFromKB} from '../../formatters/formatFileSize'
import {
    AVAILABLE_OR_NOT,
    LOGIN_MODE,
    MESSAGE_TYPE,
    PROXY_TYPE,
    VOTE_STATUS,
    VOTING_PREFERENCE_RESPONSE,
    VOTING_PREFERENCE_STATUS
} from '../../CodeMaster'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {currentMedia, HideInPC, HideInSP} from '../../styledComponents/ResponsiveConvenience'
import NatRidgeRepo from '../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import {NatGetRidge, RidgeData} from '../../__NoAutomatedTests/components/ridge/repository/NatGetRidge'
import {WideMainContainer} from '../../styledComponents/ContentsArea'
import ResponsiveDialog from '../shared/ResponsiveDialog'
import PPSelectForResident, {Option} from '../shared/forms/resident/PPSelectForResident'
import {PPTextAreaForResident} from '../shared/forms/resident/PPTextAreaForResident'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../shared/hoc/createResidentWithErrorHandlingPage'
import MessageDialogComponent from '../../common/resident/MessageDialogComponent'
import {Messages} from '../../Messages'
import {HKConstants} from '../../HKConstants'
import {GeneralMeetingQuestion} from './model/GeneralMeetingQuestion'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {
    ResidentLoginInfoSessionStorageKey
} from '../../__NoAutomatedTests/common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {formatNumberWithCommas} from '../../formatters/formatNumberWithCommas'
import {
    NatGetCurrentDateTime
} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import Scroll from 'react-scroll'
import {GeneralMeetingQuestionsOfAssoc} from './model/GeneralMeetingQuestionsOfAssoc'
import NatResidentMessageDialogComponent
    from '../../__NoAutomatedTests/components/common/resident/NatResidentMessageDialogComponent'
import {Location} from 'react-router-dom'
import {withStyles} from '@mui/styles'
import {HttpError} from '../../network/errors/HttpError'
import {
    HeadingAreaMessageComponentForResident
} from '../shared/pageBaseComponents/HeadingAreaMessageComponentForResident'
import {HttpStatusCode} from '../../network/Constants'
import {ErrorResponseBody} from '../../network/response/ErrorResponseBody'
import ColonSeparatedItem from '../shared/ColonSeparatedItem'

const ScrollElement = Scroll.Element

const scroller = Scroll.scroller

type ErrorCategory = 'votingPreference' | 'question'

interface HttpErrorObject {
    status: HttpStatusCode
    responseBody: ErrorResponseBody
}

interface ResidentGeneralMeetingDetailLocationState {
    previousPageUrl: string
    votingPreferenceHttpError?: HttpErrorObject
}

interface Props {
    location: Location<ResidentGeneralMeetingDetailLocationState>
    condominiumCd: string
    generalMeetingId: number
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    ridgeRepo: NatRidgeRepo
}

interface State {
    previousPageUrl: string
    currentDateTime: Date
    ridgeList: RidgeData[]
    residentGeneralMeeting: Nullable<ResidentGeneralMeeting>
    isMultiAssocBelonging: boolean,
    belongingAssocOptionList: Option[]
    proposalOptionList: Option[]
    selectedAssocId: string
    selectedProposalId: string
    inputQuestion: string
    focusedQuestion: Nullable<GeneralMeetingQuestion>
    isOpenQuestionSendDialog: boolean
    isOpenQuestionSendConfirmationDialog: boolean
    isOpenQuestionLimitExceededDialog: boolean
    isOpenQuestionDeleteConfirmationDialog: boolean
    isOpenAdminDialog: boolean
    isOpenQuestionMenu: boolean
    questionMenuButton: Nullable<HTMLElement>
    questionSendButtonDisabled: boolean
    errorCategory: Nullable<ErrorCategory>
}

class ResidentGeneralMeetingDetailPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {
    private votingPreferenceDispRef: React.RefObject<HTMLDivElement>
    private questionDispRef: React.RefObject<HTMLDivElement>

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            previousPageUrl: this.props.location.state?.previousPageUrl ??
                `/resident/condominiums/${this.props.condominiumCd}/general-meetings`,
            currentDateTime: new Date(),
            ridgeList: [],
            residentGeneralMeeting: null,
            isMultiAssocBelonging: false,
            belongingAssocOptionList: [
                {
                    value: '',
                    label: '',
                },
            ],
            proposalOptionList: [
                {
                    value: '',
                    label: '',
                },
            ],
            selectedAssocId: '',
            selectedProposalId: '',
            inputQuestion: '',
            focusedQuestion: null,
            isOpenQuestionSendDialog: false,
            isOpenQuestionSendConfirmationDialog: false,
            isOpenQuestionLimitExceededDialog: false,
            isOpenQuestionDeleteConfirmationDialog: false,
            isOpenAdminDialog: false,
            isOpenQuestionMenu: false,
            questionMenuButton: null,
            questionSendButtonDisabled: true,
            errorCategory: null,
        }

        this.votingPreferenceDispRef = React.createRef()
        this.questionDispRef = React.createRef()

        this.getCurrentDateTime = this.getCurrentDateTime.bind(this)
        this.getRidgeList = this.getRidgeList.bind(this)
        this.isSameOrBeforeQuestionDeadline = this.isSameOrBeforeQuestionDeadline.bind(this)
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
        this.handleVotingPreferenceLinkClick = this.handleVotingPreferenceLinkClick.bind(this)
        this.handleQuestionButtonClick = this.handleQuestionButtonClick.bind(this)
        this.handleAssocSelectChange = this.handleAssocSelectChange.bind(this)
        this.handleProposalSelectChange = this.handleProposalSelectChange.bind(this)
        this.handleQuestionTextAreaChange = this.handleQuestionTextAreaChange.bind(this)
        this.handleQuestionSendButtonClick = this.handleQuestionSendButtonClick.bind(this)
        this.questionSendDialogClose = this.questionSendDialogClose.bind(this)
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this)
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
        this.questionSendConfirmDialogClose = this.questionSendConfirmDialogClose.bind(this)
        this.handleConfirmDialogCancelClick = this.handleConfirmDialogCancelClick.bind(this)
        this.handleConfirmDialogOkClick = this.handleConfirmDialogOkClick.bind(this)
        this.handleLimitExceededDialogOkClick = this.handleLimitExceededDialogOkClick.bind(this)
        this.handleQuestionEllipsisClick = this.handleQuestionEllipsisClick.bind(this)
        this.handleCloseQuestionMenu = this.handleCloseQuestionMenu.bind(this)
        this.handleQuestionDeleteButtonClick = this.handleQuestionDeleteButtonClick.bind(this)
        this.handleQuestionDeleteConfirmationDialogOkClick
            = this.handleQuestionDeleteConfirmationDialogOkClick.bind(this)
        this.handleQuestionDeleteConfirmationDialogCancelClick
            = this.handleQuestionDeleteConfirmationDialogCancelClick.bind(this)
        this.handleAdminDialogOkClick = this.handleAdminDialogOkClick.bind(this)
        this.showHttpError = this.showHttpError.bind(this)
        this.renderQuestionMenu = this.renderQuestionMenu.bind(this)
        this.renderQuestionSendDialog = this.renderQuestionSendDialog.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {
            location,
        } = this.props

        await this.initPage()

        if (location.state?.votingPreferenceHttpError) {
            const httpError = new HttpError(
                location.state.votingPreferenceHttpError.status,
                location.state.votingPreferenceHttpError.responseBody,
            )
            this.showHttpError('votingPreference', httpError)
        }
    }

    private async initPage(): Promise<void> {
        const {
            eventEmitter,
        } = this.props

        await eventEmitter.showLoading()
        try {
            const [
                currentDateTimeResponse,
                ridgeListResponse,
                residentGeneralMeetingResponse,
            ] = await Promise.all([
                this.getCurrentDateTime(),
                this.getRidgeList(),
                this.getResidentGeneralMeeting(),
            ])

            if (!currentDateTimeResponse || !currentDateTimeResponse.details) {
                return
            }

            if (!ridgeListResponse || !ridgeListResponse.details) {
                return
            }

            if (!residentGeneralMeetingResponse || !residentGeneralMeetingResponse.details) {
                return
            }

            const residentGeneralMeeting = residentGeneralMeetingResponse.details
            const belongingAssocList = residentGeneralMeeting.generalMeetingQuestionsOfAssocList
            let belongingAssocOptionList: Option[] = []
            let selectedAssocId = ''
            if (belongingAssocList.length !== 1) {
                belongingAssocOptionList = residentGeneralMeeting.generalMeetingQuestionsOfAssocList.map(
                    generalMeetingQuestionOfAssoc => ({
                        value: String(generalMeetingQuestionOfAssoc.assocId),
                        label: residentGeneralMeeting.assocIdNameList
                            .find(assocIdName =>
                                assocIdName.assocId === generalMeetingQuestionOfAssoc.assocId)?.assocName ?? ''
                    })
                )
            } else {
                selectedAssocId = String(belongingAssocList[0].assocId)
            }

            belongingAssocOptionList.unshift(
                {
                    value: '',
                    label: '',
                }
            )

            this.setState({
                currentDateTime: new Date(currentDateTimeResponse.details.currentDateTime),
                ridgeList: ridgeListResponse.details,
                residentGeneralMeeting: residentGeneralMeeting,
                isMultiAssocBelonging: residentGeneralMeeting.generalMeetingQuestionsOfAssocList.length > 1,
                belongingAssocOptionList: belongingAssocOptionList,
                selectedAssocId: selectedAssocId,
            })
        } finally {
            eventEmitter.closeLoading()
        }
    }

    async componentDidUpdate(
        prevProps: Readonly<Props & ResidentPagePropsSet>,
        prevState: Readonly<State>
    ): Promise<void> {
        if (prevState.selectedAssocId !== this.state.selectedAssocId) {
            this.updateProposalOptionList()
        }
    }

    private updateProposalOptionList(): void {
        try {
            const {
                residentGeneralMeeting,
            } = this.state

            if (!residentGeneralMeeting) {
                return
            }

            const proposalList = residentGeneralMeeting?.generalMeetingProposalsOfAssocList.find(
                generalMeetingProposalsOfAssoc =>
                    String(generalMeetingProposalsOfAssoc.assocId) === this.state.selectedAssocId
            )?.generalMeetingProposalList

            const proposalOptionList = proposalList
                ? proposalList.map(
                    proposal => ({
                        value: String(proposal.proposalId),
                        label: `第${proposal.proposalNumber}号議案　${proposal.proposalName}` ?? '',
                    })
                )
                : []

            proposalOptionList.unshift(
                {
                    value: '',
                    label: '',
                }
            )

            this.setState({proposalOptionList: proposalOptionList})
        } finally {
            this.setState({selectedProposalId: ''})
        }
    }

    async getResidentGeneralMeeting(): Promise<Nullable<ResidentGeneralMeetingResponse>> {
        const {
            navigate,
            condominiumCd,
            generalMeetingId,
            residentGeneralMeetingRepo,
        } = this.props

        return await NatAsyncCallFunction(
            residentGeneralMeetingRepo.getResidentGeneralMeeting.bind(
                residentGeneralMeetingRepo,
                condominiumCd,
                generalMeetingId,
            ),
            navigate,
        )
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {
            navigate,
            currentDateTimeRepo,
        } = this.props

        return NatAsyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(
                currentDateTimeRepo,
            ),
            navigate,
        )
    }

    async getRidgeList(): Promise<Nullable<NatGetRidge>> {
        const {
            navigate,
            condominiumCd,
            ridgeRepo,
        } = this.props

        return NatAsyncCallFunction(
            ridgeRepo.getRidgeList.bind(
                ridgeRepo,
                condominiumCd,
            ),
            navigate,
        )
    }

    isSameOrBeforeQuestionDeadline(): boolean {
        const {
            currentDateTime,
            residentGeneralMeeting,
        } = this.state

        if (!residentGeneralMeeting || !residentGeneralMeeting.questionDeadline) {
            return false
        }

        const currentDate = new Date(currentDateTime)
        currentDate.setHours(0, 0, 0, 0)
        const questionDeadline = residentGeneralMeeting.questionDeadline

        return currentDate.getTime() <= questionDeadline.getTime()
    }

    showHttpError(errorCategory: ErrorCategory, httpError: HttpError): void {
        this.setState({
            errorCategory: errorCategory,
        }, async () => {
            await httpError.broadcast(this.props.eventEmitter)
        })
    }

    handleBackButtonClick(): void {
        this.props.navigate(
            this.state.previousPageUrl,
        )
    }

    handleVotingPreferenceLinkClick(votingPreference: ResidentVotingPreference): void {
        const {condominiumCd, generalMeetingId} = this.props
        const {residentGeneralMeeting} = this.state

        if (!residentGeneralMeeting) {
            return
        }

        this.props.navigate(
            `/resident/condominiums/${condominiumCd}/general-meetings/${generalMeetingId}/assocs/${votingPreference.assocId}/voting-preference/method-selection`,
        )
    }

    handleQuestionButtonClick(): void {
        const {
            residentGeneralMeeting,
            isMultiAssocBelonging,
            selectedAssocId
        } = this.state

        if (!residentGeneralMeeting) {
            return
        }

        const questionsOfAssocList = residentGeneralMeeting.generalMeetingQuestionsOfAssocList

        const totalQuestionCount = questionsOfAssocList.reduce(
            (total: number, questionsOfAssoc: GeneralMeetingQuestionsOfAssoc) =>
                total + questionsOfAssoc.generalMeetingQuestionList.length,
            0,
        )


        if (totalQuestionCount >= HKConstants.VMN.GMT.MAX_NUMBER_OF_QUESTION_COUNT) {
            this.setState({
                isOpenQuestionLimitExceededDialog: true,
                errorCategory: null,
            })
            return
        }

        this.setState({
            isOpenQuestionSendDialog: true,
            selectedAssocId: isMultiAssocBelonging ? '' : selectedAssocId,
            selectedProposalId: '',
            inputQuestion: '',
            errorCategory: null,
        })
    }

    handleAssocSelectChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({selectedAssocId: event.target.value})
    }

    handleProposalSelectChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({selectedProposalId: event.target.value})
    }

    handleQuestionTextAreaChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({inputQuestion: event.target.value})
    }

    isAdminUser(): boolean {
        return SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.ADMIN.value
    }

    questionSendDialogClose(): void {
        this.setState({isOpenQuestionSendDialog: false})
    }

    handleCloseButtonClick(): void {
        this.questionSendDialogClose()
    }

    handleCancelButtonClick(): void {
        this.questionSendDialogClose()
    }

    handleQuestionSendButtonClick(): void {
        if (this.isAdminUser()) {
            this.setState({isOpenAdminDialog: true})
            return
        }

        this.setState({
            isOpenQuestionSendConfirmationDialog: true,
        })
    }

    questionSendConfirmDialogClose(): void {
        this.setState({
            isOpenQuestionSendConfirmationDialog: false,
        })
    }

    handleConfirmDialogCancelClick(): void {
        this.questionSendConfirmDialogClose()
    }

    async handleConfirmDialogOkClick(): Promise<void> {
        const {
            residentGeneralMeetingRepo,
            condominiumCd,
            generalMeetingId,
            eventEmitter,
        } = this.props

        const {
            selectedAssocId,
            selectedProposalId,
            inputQuestion,
        } = this.state

        await eventEmitter.showLoading()
        try {
            const response = await this.props.asyncCallFunction(
                // @ts-ignore
                residentGeneralMeetingRepo.registerGeneralMeetingQuestion.bind(
                    residentGeneralMeetingRepo,
                    condominiumCd,
                    generalMeetingId,
                    Number(selectedAssocId),
                    Number(selectedProposalId),
                    inputQuestion,
                ),
                async (httpErrorOrNetworkError) => {
                    if (httpErrorOrNetworkError instanceof HttpError) {
                        const requestItemErrors = httpErrorOrNetworkError.responseBody.requestItemErrors

                        if (requestItemErrors.length === 0) {
                            this.questionSendDialogClose()
                            await this.initPage()
                            this.showHttpError('question', httpErrorOrNetworkError)
                        } else {
                            await httpErrorOrNetworkError.broadcast(eventEmitter)
                        }

                    }
                },
            )

            if (!response || response.requestError !== null) {
                return
            }

            this.questionSendDialogClose()
            await this.initPage()

            const registeredQuestionId = response.details

            scroller.scrollTo(`question-${registeredQuestionId}`, {
                delay: 100,
                duration: 500,
                smooth: true,
                offset: -60,
            })
        } finally {
            eventEmitter.closeLoading()
            this.questionSendConfirmDialogClose()
        }
    }

    handleQuestionEllipsisClick(
        event: React.MouseEvent<HTMLElement>,
        generalMeetingQuestion: GeneralMeetingQuestion
    ): void {
        this.setState({
            focusedQuestion: generalMeetingQuestion,
            isOpenQuestionMenu: true,
            questionMenuButton: event.currentTarget,
        })
    }

    handleCloseQuestionMenu(): void {
        this.setState({
            isOpenQuestionMenu: false,
            questionMenuButton: null,
        })
    }

    handleQuestionDeleteButtonClick(): void {
        this.setState({
            isOpenQuestionMenu: false,
            isOpenQuestionDeleteConfirmationDialog: true,
            errorCategory: null,
        })
    }

    async handleQuestionDeleteConfirmationDialogOkClick(): Promise<void> {
        const {
            residentGeneralMeetingRepo,
            condominiumCd,
            generalMeetingId,
            eventEmitter,
        } = this.props

        const {
            focusedQuestion,
        } = this.state

        if (!focusedQuestion) {
            return
        }

        await eventEmitter.showLoading()
        try {
            const response = await this.props.asyncCallFunction(
                // @ts-ignore
                residentGeneralMeetingRepo.deleteGeneralMeetingQuestion.bind(
                    residentGeneralMeetingRepo,
                    condominiumCd,
                    generalMeetingId,
                    focusedQuestion.assocId,
                    focusedQuestion.proposal.proposalId,
                    focusedQuestion.questionId,
                ),
                async (httpErrorOrNetworkError) => {
                    if (httpErrorOrNetworkError instanceof HttpError) {
                        await this.initPage()
                        this.showHttpError('question', httpErrorOrNetworkError)
                    }
                },
            )

            if (!response) {
                return
            }

            await this.initPage()

        } finally {
            eventEmitter.closeLoading()
            this.setState({
                isOpenQuestionDeleteConfirmationDialog: false,
            })
        }
    }

    handleQuestionDeleteConfirmationDialogCancelClick(): void {
        this.setState({
            isOpenQuestionDeleteConfirmationDialog: false,
        })
    }

    renderVotingPreference(votingPreference: ResidentVotingPreference): ReactNode {
        const {ridgeList} = this.state

        let votingPreferenceContent: ReactNode

        if (votingPreference.votingPreferenceStatus !== VOTING_PREFERENCE_STATUS.BEFORE_NET_RESPONDED) {
            switch (votingPreference.votingPreferenceResponse) {
                case VOTING_PREFERENCE_RESPONSE.ATTENDANCE:
                    votingPreferenceContent = <div><b>出席</b></div>
                    break
                case VOTING_PREFERENCE_RESPONSE.PROXY:
                    if (!votingPreference.residentProxyVoter) {
                        return
                    }
                    if (votingPreference.residentProxyVoter.proxyType === PROXY_TYPE.CHAIRMAN) {
                        votingPreferenceContent = <div><b>議長へ委任</b></div>
                    } else {
                        votingPreferenceContent = <>
                            <div><b>代理人を指定して委任</b></div>
                            {ridgeList.length > 1 && <ColonSeparatedItem label={'棟名'}>
                                <b>{votingPreference.residentProxyVoter.proxyVoterRidgeName || '棟名なし'}</b>
                            </ColonSeparatedItem>}
                            <div>部屋番号：<b>{votingPreference.residentProxyVoter.proxyVoterRoomNumber}</b></div>
                            <ColonSeparatedItem label={'氏名'}>
                                <b>{votingPreference.residentProxyVoter.proxyVoterName}</b>
                            </ColonSeparatedItem>
                        </>
                    }
                    break
                case VOTING_PREFERENCE_RESPONSE.VOTING:
                    if (!votingPreference.residentProposalResponseList) {
                        return
                    }
                    if (!this.state.residentGeneralMeeting) {
                        return
                    }
                    const proposalsOfAssoc = this.state.residentGeneralMeeting.generalMeetingProposalsOfAssocList
                        .find((item) => item.assocId === votingPreference.assocId)
                    if (!proposalsOfAssoc) {
                        throw Error('対象管理組合の議案がない')
                    }

                    const responseByProposalId = new Map(
                        votingPreference.residentProposalResponseList.map(
                            proposalResponse => [proposalResponse.proposalId, proposalResponse]
                        )
                    )
                    votingPreferenceContent = <>
                        <div><b>議決権行使</b></div>
                        {proposalsOfAssoc.generalMeetingProposalList.map(
                            proposal => {
                                if (proposal.proposalId === null) {
                                    throw Error('議案IDが不正')
                                }

                                const proposalResponse = responseByProposalId.get(proposal.proposalId)
                                return (
                                    <div key={proposal.proposalId}>
                                        {`第${proposal.proposalNumber}号議案`}：
                                        <b>
                                            {proposalResponse &&
                                            proposalResponse.proposalResponse.value !== VOTE_STATUS.ABSTAIN.value
                                                ? proposalResponse.proposalResponse.label
                                                : ''}
                                        </b>
                                    </div>
                                )
                            }
                        )}
                    </>
                    break
            }
        }

        return <VotingPreference
            key={votingPreference.votingPreferenceId}
            status={votingPreference.votingPreferenceStatus}
        >
            <VotingPreferenceHeader status={votingPreference.votingPreferenceStatus}>
                {votingPreference.assocName}
            </VotingPreferenceHeader>
            <VotingPreferenceContent>
                <div>
                    <VotingPreferenceStatusLabel status={votingPreference.votingPreferenceStatus}>
                        {votingPreference.votingPreferenceStatus.label}
                    </VotingPreferenceStatusLabel>
                    {votingPreferenceContent}
                </div>
                {votingPreference.votingPreferenceStatus !== VOTING_PREFERENCE_STATUS.CLOSED &&
                    <VotingPreferenceLink onClick={() => this.handleVotingPreferenceLinkClick(votingPreference)}>
                        {votingPreference.votingPreferenceStatus === VOTING_PREFERENCE_STATUS.BEFORE_NET_RESPONDED
                            ? '意思表明する'
                            : '変更する'}
                    </VotingPreferenceLink>
                }
            </VotingPreferenceContent>
        </VotingPreference>
    }

    renderQuestion(generalMeetingQuestion: GeneralMeetingQuestion): ReactNode {
        return <ScrollElement
            key={`question-${generalMeetingQuestion.questionId}`}
            name={`question-${generalMeetingQuestion.questionId}`}
        >
            <QuestionItemArea>
                <QuestionHeaderArea>
                    <QuestionHeaderLeftArea>
                        第{generalMeetingQuestion.proposal.proposalNumber}号議案
                    </QuestionHeaderLeftArea>
                    <QuestionHeaderRightArea>
                        <div>{formatDatetimeSlashSeparatorFromDate(generalMeetingQuestion.questionSendDateTime)}</div>
                        {this.isSameOrBeforeQuestionDeadline() && <UnstyledLinkStyledButton
                            onClick={(event) => this.handleQuestionEllipsisClick(
                                event,
                                generalMeetingQuestion
                            )}
                        >
                            <FontAwesomeIcon icon={faEllipsisH} color={Colors.AccentDark} fontSize={'19px'}/>
                        </UnstyledLinkStyledButton>}
                    </QuestionHeaderRightArea>
                </QuestionHeaderArea>
                <QuestionContentArea>
                    <NoMarginPre>{generalMeetingQuestion.question}</NoMarginPre>
                </QuestionContentArea>
            </QuestionItemArea>
        </ScrollElement>
    }

    renderQuestionMenu(): ReactNode {
        const questionMenuNode = <PopoverButton onClick={this.handleQuestionDeleteButtonClick}>
            <FullWidthLeftRowFlexContainer>
                <DeleteMenuIconWrapper><DeleteForever/></DeleteMenuIconWrapper>
                <Box width={'15px'}/>
                質問を削除
            </FullWidthLeftRowFlexContainer>
        </PopoverButton>

        return <>
            <HideInSP>
                <QuestionMenuPopover
                    open={this.state.isOpenQuestionMenu}
                    onClose={this.handleCloseQuestionMenu}
                    anchorEl={this.state.questionMenuButton}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    transformOrigin={{vertical: 'top', horizontal: 'center'}}
                >
                    {questionMenuNode}
                </QuestionMenuPopover>
            </HideInSP>
            <HideInPC>
                <QuestionMenuDrawer
                    open={this.state.isOpenQuestionMenu}
                    onClose={this.handleCloseQuestionMenu}
                    anchor={'bottom'}
                >
                    {questionMenuNode}
                </QuestionMenuDrawer>
            </HideInPC>
        </>
    }

    renderQuestionSendDialog(): ReactNode {
        const {
            isOpenQuestionSendDialog,
            belongingAssocOptionList,
            proposalOptionList,
            selectedAssocId,
            selectedProposalId,
            inputQuestion,
        } = this.state

        const isQuestionSendButtonDisabled = !(selectedAssocId && selectedProposalId && inputQuestion)

        return <ResponsiveDialog
            id={'pp-dialog'}
            open={isOpenQuestionSendDialog}
            transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
            maxWidth={'sm'}
            fullWidth
        >
            <QuestionSendDialogHeaderArea>
                <FullWidthRowFlexContainer>
                    <QuestionSendDialogTitle>質問</QuestionSendDialogTitle>
                    <DialogCloseButton onClick={this.handleCloseButtonClick} id={'close'}>
                        <Close fontSize={'large'}/>
                    </DialogCloseButton>
                </FullWidthRowFlexContainer>
            </QuestionSendDialogHeaderArea>
            <QuestionSendDialogContentArea>
                <QuestionSendDialogFormArea>
                    {(belongingAssocOptionList.length - 1) > 1 && <ResidentLabeledContentComponent
                        label={'管理組合'}
                        labelPosition={'center'}
                        required
                        isVertical
                        content={
                            <PPSelectForResident
                                inputProps={{
                                    value: selectedAssocId,
                                }}
                                placeholder={'管理組合名を選択してください'}
                                onChange={this.handleAssocSelectChange}
                                options={belongingAssocOptionList}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />}
                    <ResidentLabeledContentComponent
                        label={'議案'}
                        labelPosition={'center'}
                        required
                        isVertical
                        content={
                            <PPSelectForResident
                                inputProps={{
                                    value: selectedProposalId,
                                }}
                                placeholder={'議案を選択してください'}
                                onChange={this.handleProposalSelectChange}
                                options={proposalOptionList}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <ResidentLabeledContentComponent
                        label={'質問'}
                        labelPosition={'center'}
                        required
                        isVertical
                        content={<QuestionSendDialogQuestionTextArea>
                            <StyledPPTextAreaForResident
                                inputProps={{
                                    maxLength: 1000,
                                    value: inputQuestion,
                                    placeholder: '質問を入力してください\n最大1,000文字',
                                    height: '250px'
                                }}
                                onChange={this.handleQuestionTextAreaChange}
                                eventKeys={['question']}
                                eventEmitter={this.props.eventEmitter}
                            />
                            <QuestionInputCharacterCount>
                                {formatNumberWithCommas(inputQuestion.length)} / 1,000字
                            </QuestionInputCharacterCount>
                        </QuestionSendDialogQuestionTextArea>
                        }
                    />
                    <QuestionSendDialogButtonArea>
                        <UnstyledLinkStyledButton
                            onClick={this.handleCancelButtonClick}>キャンセル</UnstyledLinkStyledButton>
                        <SubmitPrimaryButton
                            onClick={this.handleQuestionSendButtonClick}
                            disabled={isQuestionSendButtonDisabled}
                        >
                            送信する
                        </SubmitPrimaryButton>
                    </QuestionSendDialogButtonArea>
                </QuestionSendDialogFormArea>
            </QuestionSendDialogContentArea>
        </ResponsiveDialog>
    }

    renderQuestionSendConfirmationDialog(): ReactElement {
        return <MessageDialogComponent
            open={this.state.isOpenQuestionSendConfirmationDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WGMTR0006.errorLevel,
                message: Messages.WGMTR0006.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleConfirmDialogCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleConfirmDialogOkClick,
                    },
                ],
            }}
        />
    }

    handleLimitExceededDialogOkClick(): void {
        this.setState({isOpenQuestionLimitExceededDialog: false})
    }

    renderQuestionLimitExceededDialog(): ReactElement {
        return <MessageDialogComponent
            open={this.state.isOpenQuestionLimitExceededDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WGMTR0007.errorLevel,
                message: Messages.WGMTR0007.toString(HKConstants.VMN.GMT.MAX_NUMBER_OF_QUESTION_COUNT),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleLimitExceededDialogOkClick,
                    },
                ],
            }}
        />
    }

    renderQuestionDeleteConfirmationDialog(): ReactElement {
        return <NatResidentMessageDialogComponent
            open={this.state.isOpenQuestionDeleteConfirmationDialog}
            params={{
                title: '削除確認',
                titleIcon: <DeleteIconWrapper><DeleteForever/></DeleteIconWrapper>,
                errorLevel: MESSAGE_TYPE.ERROR,
                message: Messages.IOPCC0029.toString('質問'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: '削除する',
                        buttonHandler: this.handleQuestionDeleteConfirmationDialogOkClick,
                        color: Colors.Alert
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleQuestionDeleteConfirmationDialogCancelClick,
                    },
                ],
            }}
        />
    }

    handleAdminDialogOkClick(): void {
        this.setState({isOpenAdminDialog: false})
    }

    renderAdminDialog(): ReactNode {
        return <MessageDialogComponent
            open={this.state.isOpenAdminDialog}
            params={{
                title: '確認',
                errorLevel: MESSAGE_TYPE.INFORMATION,
                message: Messages.ISYCR0001.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleAdminDialogOkClick,
                    },
                ],
            }}
        />
    }

    render(): ReactNode {
        const {
            eventEmitter,
        } = this.props

        const {
            previousPageUrl,
            residentGeneralMeeting,
            isMultiAssocBelonging,
            errorCategory,
        } = this.state

        if (residentGeneralMeeting === null) {
            return null
        }

        return <>
            <PlainBackLink to={previousPageUrl}>
                戻る
            </PlainBackLink>
            <StyledDisplayItemDividerForPageTop/>
            <Box height={'15px'}/>
            <GeneralMeetingName>
                {residentGeneralMeeting.generalMeetingName}
            </GeneralMeetingName>
            <Box height={'20px'}/>
            <ContentArea>
                <div>
                    <DisplayItemTitleArea>
                        <DisplayItemTitle>開催概要</DisplayItemTitle>
                    </DisplayItemTitleArea>
                    <InformationArea>
                        <ResidentSectionComponent
                            content={<ResidentLabeledContentComponent
                                label={'管理組合'}
                                labelPosition={'flex-start'}
                                content={<Box fontWeight={'bold'}>
                                    {residentGeneralMeeting.assocIdNameList.map(assocIdName =>
                                        <AssocName key={assocIdName.assocId}>{assocIdName.assocName}</AssocName>
                                    )}
                                </Box>
                                }
                            />}
                        />
                        <ResidentSectionComponent
                            content={<ResidentLabeledContentComponent
                                label={'開催日'}
                                labelPosition={'flex-start'}
                                content={<Box fontWeight={'bold'}>
                                    {formatDateWithDayOfTheWeekFromDate(residentGeneralMeeting.generalMeetingDate)}
                                </Box>
                                }
                            />}
                        />
                        {residentGeneralMeeting.noticeContent && <ResidentSectionComponent
                            content={<ResidentLabeledContentComponent
                                label={'連絡内容'}
                                labelPosition={'flex-start'}
                                content={<NoticeContentArea>
                                    <NoMarginPre>{residentGeneralMeeting.noticeContent}</NoMarginPre>
                                </NoticeContentArea>}
                            />}
                        />}
                        <ResidentSectionComponent
                            content={<ResidentLabeledContentComponent
                                label={'資料'}
                                labelPosition={'flex-start'}
                                content={<>
                                    <div>総会の詳細につきましては、配布資料またはPDFをご確認ください。</div>
                                    <div>※ファイルサイズが大きい場合は、Wi-Fi環境下での閲覧を推奨します。</div>
                                    {residentGeneralMeeting.generalMeetingFileList.map(
                                        generalMeetingFile =>
                                            <AttachmentFileLink to={generalMeetingFile.fileDownloadPath}
                                                                target={'_blank'}
                                                                key={generalMeetingFile.fileNumber}>
                                                <AttachmentFile>
                                                    <FontAwesomeIcon icon={faFilePdf} color={'#FF6378'} size={'lg'}/>
                                                    <NoEllipsisAttachmentFileName>
                                                        {getName(generalMeetingFile.fileName)}
                                                        <br/>
                                                        {formatFileSizeFromKB(generalMeetingFile.fileSizeKB)}
                                                    </NoEllipsisAttachmentFileName>
                                                </AttachmentFile>
                                            </AttachmentFileLink>
                                    )}
                                </>}
                            />}
                        />
                    </InformationArea>
                </div>
                <div>
                    <DisplayItemTitleArea>
                        <DisplayItemTitle ref={this.votingPreferenceDispRef}>意思表明</DisplayItemTitle>
                    </DisplayItemTitleArea>
                    <ResidentSectionComponent
                        content={<>
                            {errorCategory === 'votingPreference' && <HeadingAreaMessageComponentForResident
                                eventEmitter={eventEmitter}
                                scrollRef={this.votingPreferenceDispRef}
                            />}
                            <div>総会への参加方法について、出席・委任・議決権行使のいずれかを選択してください。</div>
                            <div>
                                期限：
                                {formatDateWithDayOfTheWeekFromDate(residentGeneralMeeting.votingPreferenceDeadline)}まで
                            </div>
                            <VotingPreferenceList>
                                {residentGeneralMeeting.residentVotingPreferenceList.map(
                                    votingPreference =>
                                        this.renderVotingPreference(votingPreference)
                                )}
                            </VotingPreferenceList>
                        </>}
                    />
                </div>
                <div>
                    {residentGeneralMeeting.questionAvailability.value === AVAILABLE_OR_NOT.AVAILABLE.value && <>
                        <DisplayItemTitleArea>
                            <DisplayItemTitle ref={this.questionDispRef}>質問</DisplayItemTitle>
                        </DisplayItemTitleArea>
                        <ResidentSectionComponent
                            content={<>
                                {errorCategory === 'question' && <HeadingAreaMessageComponentForResident
                                    eventEmitter={eventEmitter}
                                    scrollRef={this.questionDispRef}
                                />}
                                <div>議案に関するご質問等は、こちらからお寄せください。</div>
                                <div>
                                    期限：{residentGeneralMeeting.questionDeadline &&
                                    formatDateWithDayOfTheWeekFromDate(residentGeneralMeeting.questionDeadline)
                                }まで
                                </div>
                                <br/>
                                <div>※本システムにはご質問に対して回答する機能はありません。あらかじめご了承ください。</div>
                                {this.isSameOrBeforeQuestionDeadline() &&
                                    <QuestionButton onClick={this.handleQuestionButtonClick}>
                                        <Comment fontSize={'large'}/>
                                        <Box marginLeft={'20px'}>
                                            質問する
                                        </Box>
                                    </QuestionButton>}
                            </>}
                        />
                        <QuestionDisplayArea>
                            {residentGeneralMeeting.generalMeetingQuestionsOfAssocList.map(
                                generalMeetingQuestionsOfAssoc => {
                                    if (generalMeetingQuestionsOfAssoc.generalMeetingQuestionList.length >= 1) {
                                        return <QuestionsOfAssocArea
                                            key={`questionList-${generalMeetingQuestionsOfAssoc.assocId}`}
                                        >
                                            {isMultiAssocBelonging && <QuestionAssocNameArea>
                                                {residentGeneralMeeting.assocIdNameList.find(assocIdName =>
                                                    assocIdName.assocId === generalMeetingQuestionsOfAssoc.assocId
                                                )?.assocName}
                                            </QuestionAssocNameArea>}
                                            <QuestionListArea>
                                                {generalMeetingQuestionsOfAssoc.generalMeetingQuestionList.map(
                                                    generalMeetingQuestion =>
                                                        this.renderQuestion(generalMeetingQuestion)
                                                )}
                                            </QuestionListArea>
                                        </QuestionsOfAssocArea>
                                    }
                                }
                            )}
                        </QuestionDisplayArea>
                    </>}
                </div>
            </ContentArea>
            <BackButton onClick={this.handleBackButtonClick}>
                戻る
            </BackButton>
            <Box height={'15px'}/>
            {this.renderQuestionMenu()}
            {this.renderQuestionSendDialog()}
            {this.renderQuestionSendConfirmationDialog()}
            {this.renderQuestionLimitExceededDialog()}
            {this.renderQuestionDeleteConfirmationDialog()}
            {this.renderAdminDialog()}
        </>
    }
}

export default createResidentWithErrorHandlingPage(ResidentGeneralMeetingDetailPage)

const StyledDisplayItemDividerForPageTop = styled(DisplayItemDividerForPageTop)`
  margin-top: 14px;
  margin-bottom: 15px;
`

const GeneralMeetingName = styled(StyledPageTitle)`
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const ContentArea = styled(FullWidthColumnFlexContainer)`
  row-gap: 15px;
  align-items: stretch;
`

const DisplayItemTitleArea = styled(WideMainContainer)`
  padding: 20px 15px 0;
`

const InformationArea = styled(FullWidthColumnFlexContainer)`
  row-gap: 5px;
`

const AssocName = styled.div`
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const NoticeContentArea = styled.div`
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const NoMarginPre = styled.pre`
  margin: 0;
  white-space: break-spaces;
  font-family: inherit;
`

const NoEllipsisAttachmentFileName = styled(AttachmentFileName)`
  text-overflow: inherit;
  white-space: inherit;
`

const VotingPreferenceList = styled(FullWidthColumnFlexContainer)`
  width: 100%;
  margin-top: 10px;
  gap: 10px;

  ${currentMedia.lessThan('sp')`
        width: calc(100% + 20px);
        margin-left: -10px;
        margin-right: -10px;
  `}
`

const VotingPreference = styled.div<{ status: VOTING_PREFERENCE_STATUS }>`
  width: 100%;
  border: 1px solid;
  border-color: ${props => props.status === VOTING_PREFERENCE_STATUS.BEFORE_NET_RESPONDED
      ? `rgba(0, 112, 176, 0.5)`
      : Colors.AccentLight
  };
`

const VotingPreferenceHeader = styled.div <{ status: VOTING_PREFERENCE_STATUS }>`
  padding: 10px 15px;
  background-color: ${props => props.status === VOTING_PREFERENCE_STATUS.BEFORE_NET_RESPONDED
      ? Colors.LightBlue
      : Colors.Background
  };
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const VotingPreferenceContent = styled(RowFlexContainer)`
  padding: 20px 15px;
`

const VotingPreferenceStatusLabel = styled.div<{ status: VOTING_PREFERENCE_STATUS }>`
  text-align: center;
  font-size: ${FontSize.Small};
  height: 18px;
  width: fit-content;
  min-width: 70px;
  padding: 0 10px;
  box-sizing: border-box;
  line-height: normal;
  white-space: nowrap;
  user-select: none;

  ${props => {
    switch (props.status) {
      case VOTING_PREFERENCE_STATUS.BEFORE_NET_RESPONDED:
        return `color: ${Colors.Body};
                background: ${Colors.LightBlue};`
      case VOTING_PREFERENCE_STATUS.RESPONDED:
        return `color: #FFF;
                background: linear-gradient(to bottom right, #009688BF 50%, #00000000 50%), #00838A;`
      case VOTING_PREFERENCE_STATUS.CLOSED:
        return `color: #FFF;
                background: ${Colors.AccentDark};`
    }
  }}
`

const VotingPreferenceLink = styled.a`
  font-size: ${FontSize.Middle};
  display: flex;
  align-items: center;
  padding: 6px 16px;

  background-color: ${Colors.Surface};
  white-space: nowrap;
  text-decoration: none;

  border: 1px solid;
  border-radius: 4px;
  border-color: ${Colors.Primary};
  color: ${Colors.Primary};
  cursor: pointer;
`

const QuestionButton = styled(PlainLinkStyledButton)`
  display: flex;
  padding: 21.5px 15px;
  margin-left: -15px;

  &:last-child {
    margin-bottom: -20px;
  }
`

const QuestionDisplayArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
`

const QuestionsOfAssocArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const QuestionAssocNameArea = styled(WideMainContainer)`
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const QuestionListArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const QuestionItemArea = styled(WideMainContainer)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
`

const QuestionHeaderArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const QuestionHeaderLeftArea = styled.div`
  font-weight: ${FontWeights.Bold};
`

const QuestionHeaderRightArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  font-size: ${FontSize.Small};
  align-items: center;
`

const QuestionContentArea = styled.div`
  overflow-wrap: anywhere;
  line-break: anywhere;
`

const BackButton = styled(StyledSecondaryButton)`
  margin-top: 20px;
`

const QuestionSendDialogHeaderArea = styled(DialogTitle)`
  && {
    padding: 17px 15px 0;
  }
`
const QuestionSendDialogTitle = styled.div`
  font-size: 20px;
  font-weight: ${FontWeights.Bold};
`

const QuestionSendDialogContentArea = styled(DialogContent)`
  && {
    padding: 15px;
  }
`
const QuestionSendDialogFormArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

const QuestionSendDialogQuestionTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
`

const StyledPPTextAreaForResident = styled(PPTextAreaForResident)`
  && {
    height: 250px;
  }
`

const QuestionInputCharacterCount = styled.div`
  color: ${Colors.AccentDark};
`

const QuestionSendDialogButtonArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: flex-end;
`

const PopoverButton = styled(UnstyledLinkStyledButton)`
  width: 100%;
  padding: 20px 20px 20px 15px;
  line-height: 24px;
  color: ${Colors.Alert};
`

const QuestionMenuPopover = withStyles({
    paper: {
        width: '245px',
        border: `1px solid ${Colors.Background}`,
        borderRadius: '10px',
    },
})(Popover)

const QuestionMenuDrawer = withStyles({
    paper: {
        border: `1px solid ${Colors.Background}`,
        borderRadius: '10px 10px 0 0',
    },
})(Drawer)

const DeleteIconWrapper = styled.div`
  line-height: 1;

  svg {
    color: ${Colors.Alert};
    font-size: ${FontSize.ExtraBig} !important;
    ${currentMedia.lessThan('sp')`
          font-size: ${FontSize.Big}!important;
        `};
  }
`

const DeleteMenuIconWrapper = styled(DeleteIconWrapper)`
  svg {
    font-size: ${FontSize.Big} !important;
  }
`
